import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { BOT_INVITE_URL } from "../data/links";
import { bindScrollMemory } from "../utils/pageMemory";

export default function HomePage({ guilds, onInvite }) {
  const active = guilds.filter((g) => g.hasBot);
  const pending = guilds.filter((g) => !g.hasBot);

  useEffect(() => bindScrollMemory("servers"), []);

  return (
    <div className="home-page">
      <header className="home-header">
        <h1>Your servers</h1>
        <p>
          Pick a server to configure. Settings sync with Discord - changes here
          or via <code>/settings</code> both apply.
        </p>
      </header>

      {active.length > 0 ? (
        <>
          <h2 className="home-section-label">With Kami installed</h2>
          <div className="server-grid">
            {active.map((g) => (
              <div key={g.id} className="server-card">
                <img
                  src={
                    g.icon
                      ? `https://cdn.discordapp.com/icons/${g.id}/${g.icon}.png`
                      : "https://cdn.discordapp.com/embed/avatars/0.png"
                  }
                  className="server-icon"
                  alt=""
                />
                <strong>{g.name}</strong>
                <p className="server-status">
                  <span className="status-dot-sm online" /> Active
                </p>
                <Link to={`/manage/${g.id}`} className="manage-btn">
                  Manage settings
                </Link>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="home-empty">
          <p>Kami isn&apos;t in any of your servers yet.</p>
          <a
            href={BOT_INVITE_URL}
            className="btn btn-primary"
            onClick={(e) => {
              if (onInvite) onInvite(e);
            }}
          >
            Add to Discord
          </a>
        </div>
      )}

      {pending.length > 0 && (
        <>
          <h2 className="home-section-label">Add Kami to these servers</h2>
          <div className="server-grid">
            {pending.map((g) => (
              <div key={g.id} className="server-card inactive">
                <img
                  src={
                    g.icon
                      ? `https://cdn.discordapp.com/icons/${g.id}/${g.icon}.png`
                      : "https://cdn.discordapp.com/embed/avatars/0.png"
                  }
                  className="server-icon grey"
                  alt=""
                />
                <strong>{g.name}</strong>
                <p className="server-status muted">Not installed</p>
                <button
                  type="button"
                  className="manage-btn invite-btn"
                  onClick={() =>
                    window.open(`${BOT_INVITE_URL}&guild_id=${g.id}`, "_self")
                  }
                >
                  Invite Kami
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      <div className="home-links">
        <Link to="/help">Browse commands</Link>
      </div>
    </div>
  );
}
